import { Shield, Server, Award, CreditCard } from 'lucide-react'
import './LandingTrustBar.css'

const badges = [
  {
    Icon: Shield,
    title: '100% DSGVO-konform',
    desc: 'Deutsche Datenschutzstandards',
  },
  {
    Icon: Server,
    title: 'Server in Deutschland',
    desc: 'Daten verlassen nicht die EU',
  },
  {
    Icon: Award,
    title: 'Kein Account nötig',
    desc: 'Einfach hochladen und fertig',
  },
  {
    Icon: CreditCard,
    title: '€4,99 einmalig',
    desc: 'Kein Abo, keine versteckten Kosten',
  },
]

export function LandingTrustBar() {
  return (
    <section className="trust-section">
      <div className="trust-grid">
        {badges.map(({ Icon, title, desc }, i) => (
          <div key={i} className="trust-card">
            <div className="trust-card-icon">
              <Icon size={22} />
            </div>
            <h3 className="trust-card-title">{title}</h3>
            <p className="trust-card-desc">{desc}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
